import { I07SparkleAppointmentConfirmationProps } from './I07SparkleAppointmentConfirmation.types';
import { ContentContainer, Spinner } from '@ahc-digital/component-library';
import Script from 'next/script';
import { useState } from 'react';
import { sparkleUtils } from 'src/shared/sparkle-utils';
import { useSparkleApi } from 'src/shared/SparkleApi.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: I07SparkleAppointmentConfirmationProps): JSX.Element => {
  const sparkleApi = useSparkleApi();
  const [isError, setIsError] = useState(false);
  const containerID =
    props?.params?.AnchorLinkTargetName ?? 'sparkle-appointment-booking-container';
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const applyContent = async (slug: string) => {
    const contentDiv = document.getElementById(containerID);
    if (!contentDiv) return;

    const { isSuccess, textContent: htmlContent } =
      await sparkleApi.fetchProviderConfirmationContent(slug);

    if (!isSuccess) {
      setIsError(true);
      return;
    }

    sparkleUtils.applyHtmlSnippet(htmlContent, contentDiv);
  };

  return (
    <>
      <Script
        src="https://code.jquery.com/jquery-3.7.1.min.js"
        integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo="
        crossOrigin="anonymous"
        onError={() => setIsError(true)}
        onReady={() => {
          const slug = window.location.pathname.split('/').pop();
          if (!slug) return;

          applyContent(slug);
        }}
      />
      <div
        id={containerID}
        className={translationClasses(props?.params)}
        data-component={marketingRenderingName}
      >
        {isError ? (
          <></>
        ) : (
          <ContentContainer spacing="40-24">
            <Spinner />
          </ContentContainer>
        )}
      </div>
    </>
  );
};
